export default {
  CONFIRM_ADMIN_REQUEST: 'CONFIRM_ADMIN_REQUEST',
  CONFIRM_ADMIN_SUCCESS: 'CONFIRM_ADMIN_SUCCESS',
  CONFIRM_ADMIN_FAILURE: 'CONFIRM_ADMIN_FAILURE',
  INVITE_ADMIN_REQUEST: 'INVITE_ADMIN_REQUEST',
  INVITE_ADMIN_SUCCESS: 'INVITE_ADMIN_SUCCESS',
  INVITE_ADMIN_FAILURE: 'INVITE_ADMIN_FAILURE',
  UPDATE_INVITED_ADMIN: 'UPDATE_INVITED_ADMIN'
}
